// extracted by mini-css-extract-plugin
module.exports = {"licenceBox":"style_licenceBox__HHIph4B7CJ9d9hAZN0Skh","list":"style_list__3rYUiCkUSb8CEt71SF39Ji"};